export default "__VITE_ASSET__R7tLZiu2__"